import { QarepaEnumInformation } from '@qarepa/common';

export enum ScheduleSourceEnum {
  MANUAL = 'MANUAL',
  WORK_SCHEDULE = 'WORK_SCHEDULE',
}

export const ScheduleSourceArray = [
  ScheduleSourceEnum.MANUAL,
  ScheduleSourceEnum.WORK_SCHEDULE,
];

export const ScheduleSourceInfo: QarepaEnumInformation<ScheduleSourceEnum> = {
  [ScheduleSourceEnum.MANUAL]: {
    name: $localize`Manual`,
  },

  [ScheduleSourceEnum.WORK_SCHEDULE]: {
    name: $localize`Horario de trabajo`,
  },
};
